import React, { useEffect } from 'react'
import { useField, useFormikContext } from 'formik'

export const CheckAllModulesField = props => {
    const {
        values,
        setFieldValue,

    } = useFormikContext()
    const [field] = useField(props)

    useEffect(() => {

        if (values.checkAllModules && values.checkedModules.length !== values.modules.length) {
            setFieldValue('checkedModules', values.modules.map(i => i.id.toString()))
        }

        if (!values.checkAllModules && values.checkedModules.length === values.modules.length) {
            setFieldValue('checkedModules', [])
        }

    }, [values.checkAllModules])

    useEffect(() => {

        values.checkedModules.length === values.modules.length
            ? setFieldValue('checkAllModules', true)
            : setFieldValue('checkAllModules', false)

    }, [values.checkedModules.length])

    return <input {...props} {...field} style={props.style}/>
}